import http from './_http'

const rule = {
  get: (id) => http.get(`api/v3/rule/${id}`),
  list: (m) => http.post(`api/v3/rule/search`, m),
  add: (m) => http.post(`api/v3/rule/`, m),
  update: (m) => http.put(`api/v3/rule`, m),
  update_bulk: (selectId, m) => http.put(`api/v3/rule/bulk/${selectId}`, m),
  delete: (id) => http.delete(`api/v3/rule/${id}`),
}

const kisa = {
  get: (id) => http.get(`api/v3/kisa/${id}`),
  list: (m) => http.post(`api/v3/kisa/search`, m),
  add: (m) => http.post(`api/v3/kisa/`, m),
  update: (m) => http.put(`api/v3/kisa`, m),
  delete: (id) => http.delete(`api/v3/kisa/${id}`),
}

const functions = {
  rule, kisa
}
export default functions
export { rule, kisa }
